import { styled, css } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, useEffect, useCallback, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import Tooltip from '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';

const _excluded = ["large", "testId"];
const IconWrapperTile = styled(Div).attrs(_ref => {
  let {
      large,
      testId
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    height: large ? 52 : 36
  }, rest);
})`
  display: flex;
  justify-content: center;
  padding: 2px;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 1px;
  ${({
  theme
}) => css`
    border-color: ${theme.palette.black[20]};
  `}
`;

const _excluded$1 = ["key", "testId"];
const IconItemDiv = styled(Div).attrs(_ref => {
  let {
      key,
      testId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    key,
    testId: testId || key && `icon-switch-${key}`
  }, props);
})``;

const _excluded$2 = ["selected", "large", "glyph", "currentlySelected"];
const IconSwitchIcon = styled(Button).attrs(_ref => {
  let {
      selected,
      large,
      glyph,
      currentlySelected
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return _objectSpread2({
    iconOnly: true,
    variant: currentlySelected ? 'primary' : 'default',
    iconProps: {
      glyph
    },
    size: large ? 48 : 32,
    styles: {
      root: {
        width: large ? 50 : 34
      }
    }
  }, props);
})``;

const IconSwitch = ({
  items,
  onChange,
  selected,
  large = false,
  styles = {}
}) => {
  const [currentSelection, setCurrentSelected] = useState(selected);
  useEffect(() => {
    if (selected) {
      setCurrentSelected(selected);
    }
  }, [selected]);
  const onSelection = useCallback((event, {
    key
  }) => {
    setCurrentSelected(key);
    onChange(event, key);
  }, [onChange]);
  return /*#__PURE__*/createElement(IconWrapperTile, _extends({
    large: large,
    testId: "icon-switch"
  }, styles === null || styles === void 0 ? void 0 : styles.root), items.map(item => item.tooltip ? /*#__PURE__*/createElement(Tooltip, _extends({
    key: item.key
  }, item.tooltip), /*#__PURE__*/createElement(IconItemDiv, _extends({
    onClick: event => onSelection(event, item)
  }, item), /*#__PURE__*/createElement(IconSwitchIcon, _extends({
    large: large,
    currentlySelected: item.key === currentSelection,
    glyph: item.glyph
  }, styles === null || styles === void 0 ? void 0 : styles.icon)))) : /*#__PURE__*/createElement(IconItemDiv, _extends({
    key: item.key,
    onClick: event => onSelection(event, item)
  }, item), /*#__PURE__*/createElement(IconSwitchIcon, _extends({
    large: large,
    currentlySelected: item.key === currentSelection,
    glyph: item.glyph
  }, styles === null || styles === void 0 ? void 0 : styles.icon)))));
};

export default IconSwitch;
